import axios from 'axios';
import { message } from 'antd';
import { logout } from '@/utils/Auth';
import config from '@/utils/config';

const service = axios.create({
  baseURL: config.baseUrl,
  timeout: 15000,
});

message.config({
  maxCount: 1,
  rtl: true,
});

// 请求拦截
service.interceptors.request.use(
  config => {
    const token = sessionStorage.getItem('token');
    if (token) {
      config.headers['zijin-token'] = token;
    }
    return config;
  },
  error => {
    message.error('REQUEST ERROR');
    return Promise.reject(error);
  },
);

// 响应拦截
service.interceptors.response.use(
  response => {
    const { code, data } = response.data;

    // code 判断token是否失效
    if (code === 'unauthorized') {
      message.error(`token失效, 请重新登录`, 1.5, () => {
        logout();
      });
      return Promise.reject(data.reason);
    }
    return response;
  },
  error => {
    message.error('RESPONSE ERROR');
    return Promise.reject(error);
  },
);

/** get 请求 */
export function get<T> (url:string, params?: Record<string, any>) {
  return service.get<API.MyResponse<T>>(url, { params }).then(res => res.data);
}
/** post 请求 */
export function post<T> (url:string, params?: Record<string, any>) {
  return service.post<API.MyResponse<T>>(url, params).then(res => res.data);
}

export default service.request;

